// extracted by mini-css-extract-plugin
module.exports = {"circleRadiusBig":"308.5","circleRadiusSmall":"274.5","smallMediaWidth":"1700"};